<template>
  <div>
    <b-modal
      v-if="shouldShowRejectionModal && selectedItemToReject"
      title="Please add the reason to reject"
      v-model="shouldShowRejectionModal"
      size="sm"
      centered no-close-on-backdrop
      @cancel="shouldShowRejectionModal = false"
      @close="shouldShowRejectionModal = false"
      @ok="rejectPermission">
      <div>
       <p>
           <b>Sales Representative Number:</b> {{ selectedItemToReject.SalesRepresentativeNumber }}
       </p>
       <p>
           <b>Sales Representative Name:</b> {{ selectedItemToReject.SalesRepresentativeName }}
       </p>
       <p>
           <b>User Email:</b> {{ selectedItemToReject.UserEmail }}
       </p>
       <b-form-group
           label="Rejection reason*"
           label-for="rejection-reason">
           <b-form-input id="rejection-reason" v-model="rejectionReason" placeholder="Rejection reason" :state="isValidRejectionReason()"></b-form-input>
           <b-form-invalid-feedback>Please add a rejection reason</b-form-invalid-feedback>
       </b-form-group>
      </div>
    </b-modal>
    <b-modal
      v-if="showApproveModal && salesRepRequestToApprove"
      title="Are you sure you want to approve?"
      v-model="showApproveModal"
      size="sm"
      centered no-close-on-backdrop
      @cancel="showApproveModal = false"
      @close="showApproveModal = false"
      @ok="approvePermission"
    >
      <div>
       <p>
          <b>Sales Representative Number:</b> {{ salesRepRequestToApprove.SalesRepresentativeNumber }}
       </p>
       <p>
          <b>Sales Representative Name:</b> {{ salesRepRequestToApprove.SalesRepresentativeName }}
       </p>
       <p>
          <b>User Email:</b> {{ salesRepRequestToApprove.UserEmail }}
       </p>
      </div>
    </b-modal>
    <div v-if="salesRepLoading">
      <loading-overlay :isLoading="salesRepLoading" :loadingText="'Loading Sales Rep'" />
    </div>
    <div v-else-if="errorMessage !== ''" class="d-flex justify-content-center">
      <b-card title="Error" class="p-5">
        <b-card-text>{{ errorMessage }}</b-card-text>
      </b-card>
    </div>
    <div v-else-if="salesRep.Id === ''" class="d-flex justify-content-center">
      <b-card title="404" class="p-5">
        <b-card-text>Error - Sales Rep not found</b-card-text>
      </b-card>
    </div>
    <div v-else>
      <b-row class="align-items-center pb-3 my-1">
        <b-col md="12">
          <h5>
            <span v-if="_hasHistory()" class="mr-4 primary-color back-btn" @click="$router.back()">
              <b-icon icon="arrow-left"></b-icon>
            </span>
            <i class="fa fa-user fa-lg mr-2"></i>Sales Rep Profile
          </h5>
        </b-col>
      </b-row>
      <b-card header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <h3 class="mb-0">{{ salesRep.Name }} - {{ salesRep.Id }}</h3>
        </template>

        <b-tabs content-class="mt-3" justified lazy>
          <b-tab title="Sales Rep Information">
            <b-row>
              <b-col md="12" class="section-header">
                <b>Address</b>
              </b-col>
              <b-col md="12" class="section-info">
                <b-row class="my-1">
                  <b-col cols="4">Name:</b-col>
                  <b-col cols="8">{{ salesRep.Address.Name1 }}</b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col cols="4">Street:</b-col>
                  <b-col cols="8">
                    {{ salesRep.Address.Street }}
                    <p v-if="salesRep.Address.Name2 !== ''">{{ salesRep.Address.Name2 }}</p>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col cols="4">Postal Code/City:</b-col>
                  <b-col cols="4">{{ salesRep.Address.PostalCode }}</b-col>
                  <b-col cols="4">{{ salesRep.Address.City }}</b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col cols="4">Country/Region:</b-col>
                  <b-col cols="4">{{ salesRep.Address.Country }}</b-col>
                  <b-col cols="4">{{ salesRep.Address.Region }}</b-col>
                </b-row>
                <b-row class="my-1" v-if="salesRep.Address.TaxJurisdictionCode !== undefined">
                  <b-col cols="4">Tax Jurisdiction Code:</b-col>
                  <b-col cols="8">{{ salesRep.Address.TaxJurisdictionCode }}</b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="section-header">
                <b>Communication</b>
              </b-col>
              <b-col md="12" class="section-info">
                <b-row>
                  <b-col cols="4">Phone #:</b-col>
                  <b-col cols="8">{{ salesRep.Address.Phone }}</b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">Email:</b-col>
                  <b-col cols="8">
                    <div v-for="mail in salesRep.Address.Emails" :key="mail.Email">{{ mail.Email }}</div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Client List">
            <b-row>
              <b-col md="12" class="section-header">
                <b>Customers</b>
              </b-col>
              <b-col md="12" class="section-info">
                <template v-if="salesRep.Customers && salesRep.Customers.length > 0">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Customer Number</th>
                        <th>Customer Name</th>
                        <th>City</th>
                        <th>Zipcode</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="customer in salesRep.Customers" :key="customer.CustomerNumber">
                        <td>
                            <router-link
                              :to="{
                                name: 'customer',
                                params: { customerNumber: customer.CustomerNumber },
                              }"
                            >
                              {{ customer.CustomerNumber }}
                            </router-link>
                          </td>
                        <td>{{ customer.CustomerName }}</td>
                        <td>{{ customer.CustomerAddress?.City }}</td>
                        <td>{{ customer.CustomerAddress?.PostalCode }}</td>
                      </tr>
                    </tbody>
                  </table>
                </template>
                <template v-else>
                    The sales rep doesn't have any customers.
                </template>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Permissions">
            <b-row>
              <b-col md="12" class="section-header">
                <b>Users</b>
              </b-col>
              <b-col md="12" class="section-info">
                <template v-if="salesRep.Permissions && salesRep.Permissions.length > 0">
                  <b-row v-for="permission in salesRep.Permissions" :key="permission.Id">
                    <b-col>
                        {{ permission.ResourceName }}
                    </b-col>
                  </b-row>
                </template>
                <template v-else>
                    The sales rep doesn't have any users.
                </template>
              </b-col>
            </b-row>
            <b-row v-if="_isCustomerAdminSite()">
              <b-col md="12" class="section-header">
                <b>Pending Permission Requests</b>
              </b-col>
              <b-col md="12" class="section-info">
                <template v-if="salesRep.PendingPermissionRequests && salesRep.PendingPermissionRequests.length > 0">
                    <b-row v-for="permission in salesRep.PendingPermissionRequests" :key="permission.Id">
                        <b-col>{{ permission.UserName }}</b-col>
                        <b-col>
                            <b-button variant="link" @click="onApprove(permission)">
                                Approve
                            </b-button>
                        </b-col>
                        <b-col>
                            <b-button variant="link" @click="onReject(permission)">
                                Reject
                            </b-button>
                        </b-col>
                    </b-row>
                </template>
                <template v-else>
                    No pending permissions.
                </template>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import MxSite from '@/mixins/site'
import { namespace } from 'vuex-class'
import LoadingOverlay from '@/components/utility/loading-overlay.vue'
import { ISalesRepresentative } from '@/store/sales-reps/types'
import { Api } from '@/api/Api'
import { HttpMethod } from '@/api/FetchApi'
import { isCustomerAdminSite } from '@/helpers/sites.helper'

const nsSalesReps = namespace('sales-reps')

@Component({
  components: {
    LoadingOverlay,
  },
})
export default class SalesRep extends Mixins(MxSite) {
  private api = new Api()

  @nsSalesReps.Getter('salesRep')
  public salesRep!: ISalesRepresentative

  @nsSalesReps.Getter('salesRepLoading')
  public salesRepLoading!: boolean

  @nsSalesReps.Getter('errorMessage')
  public errorMessage!: string

  @nsSalesReps.Action('getSalesRep')
  public getSalesRep: any

  public rejectionReason: string | null = null

  public shouldShowRejectionModal = false
  public showApproveModal = false

  public selectedItemToReject : { Id: string, UserEmail: string, SalesRepresentativeName: string, SalesRepresentativeNumber: string } | null = null
  public salesRepRequestToApprove : { Id: string, UserEmail: string, SalesRepresentativeName: string, SalesRepresentativeNumber: string } | null = null

  public async mounted() {
    this.hideBreadcrumbDisplay(true)
    await this.getSalesRep(this.SalesRepNumber)
  }

  public onReject(item: any) {
    this.selectedItemToReject = item
    this.shouldShowRejectionModal = true
  }

  public rejectPermission() {
    const obj = { isApproved: false, rejectionStatus: this.rejectionReason, PermissionIds: [this.selectedItemToReject?.Id] }
    this.api.fetchV2({
      url: '/sales-rep/permission-requests/batchRespond',
      obj,
      method: HttpMethod.Post,
    }).then(() => {
      this.toastSuccess('Updated successfully')
      this.getSalesRep(this.SalesRepNumber)
    })
  }

  public onApprove(item: any) {
    this.salesRepRequestToApprove = item
    this.showApproveModal = true
  }

  public approvePermission() {
    this.api.fetchV2({
      url: '/sales-rep/permission-requests/batchRespond',
      obj: { isApproved: true, PermissionIds: [this.salesRepRequestToApprove?.Id] },
      method: HttpMethod.Post,
    }).then(() => {
      this.toastSuccess('Updated successfully')
      this.getSalesRep(this.SalesRepNumber)
    })
  }

  public isValidRejectionReason() {
    return this.rejectionReason && this.rejectionReason !== ''
  }

  public loadCustomer(customerNumber: string) {
    this.$router.push({
      name: 'customer',
      params: { customerNumber },
    })
  }

  public _isCustomerAdminSite() {
    return isCustomerAdminSite(this.role)
  }

  get SalesRepNumber() {
    return this.$route.params.salesRepNumber
  }
}
</script>
<style scoped>
.section-header {
  background-color: #e7f0f8;
  border-color: #a6c2ef;
  padding: 0.25rem 0.5rem;
}

.section-info {
  min-height: 30px;
  padding: 5px 10px;
}

.bordered-container {
  margin-bottom:20px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  position: relative;
  padding: 15px;
}
</style>
